import { render, staticRenderFns } from "./classNotice.vue?vue&type=template&id=5983a2bd&"
import script from "./classNotice.vue?vue&type=script&lang=js&"
export * from "./classNotice.vue?vue&type=script&lang=js&"
import style0 from "./classNotice.vue?vue&type=style&index=0&id=5983a2bd&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports